module.exports = __webpack_public_path__ + "img/Španija.b1e48aba.png";